@use "@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss";

.infoBar {
  background-color: var(--hcr-bg-secondary-color);
  padding: var(--hcr-spacing-2) var(--hcr-spacing-4);
}

.headerGrid {
  width: 100%;
}

.leftColumn {
  min-width: 0;
}

.leftSection {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  column-gap: var(--hcr-spacing-1);
  min-width: 0;
}

.leftSectionEditing {
  align-items: start;
}

.detailsGrid {
  display: flex;
  align-items: center;
  gap: var(--hcr-spacing-1);
  flex-wrap: wrap;
  min-width: 0;
}

.calculationName {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  font-weight: 700;
  font-size: var(--hcr-font-size-h3);
  line-height: var(--hcr-line-height-h3);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags {
  display: flex;
  align-items: center;
  gap: var(--hcr-spacing-half);
  flex-shrink: 0;
}

.kamLine {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  color: var(--hcr-content-secondary-color);
  font-size: var(--hcr-font-size-small);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.headerEditForm {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  max-width: 100%;
  gap: var(--hcr-spacing-1);
  min-width: 0;
  overflow: hidden;
}

.headerEditFormWithFieldError {
  align-items: start;
}

.nameEditInput {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
}

.kamEditInput {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
}

.headerEditActions {
  display: flex;
  gap: var(--hcr-spacing-half);
  align-items: center;
  align-self: center;
}

.headerEditAction {
  color: var(--hcr-content-primary-color);
}

.headerConfirmAction:enabled:hover,
.headerConfirmAction:focus-visible {
  color: var(--hcr-success-color);
}

.headerCancelAction:enabled:hover,
.headerCancelAction:focus-visible {
  color: var(--hcr-danger-color);
}

.infoIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--hcr-spacing-6);
  height: var(--hcr-spacing-6);
  color: var(--hcr-content-primary-color);
}

.lastUpdated {
  min-width: 0;
  overflow: hidden;
  color: var(--hcr-content-secondary-color);
  font-size: var(--hcr-font-size-small);
  text-overflow: ellipsis;
  white-space: nowrap;
  align-self: center;
}

.headerEditFormWithFieldError .headerEditActions,
.headerEditFormWithFieldError .infoIcon,
.headerEditFormWithFieldError .lastUpdated {
  align-self: start;
}

.submitError {
  flex-basis: 100%;
  min-width: 0;
}

.rightSection {
  display: flex;
  align-items: center;
  gap: var(--hcr-spacing-4);
  flex-shrink: 0;
}

.switchFieldset {
  margin: 0;
  padding: 0;
  border: none;
}

.disabledToggleHoverTarget {
  display: inline-flex;
  align-items: center;
}

@include honeycomb-helpers.on-range(zero, md) {
  .headerGrid {
    align-items: flex-start;
  }

  .leftColumn,
  .rightColumn {
    width: 100%;
  }

  .headerEditForm {
    align-items: stretch;
  }

  .rightSection {
    justify-content: flex-end;
  }

  .tags,
  .lastUpdated {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .nameEditInput,
  .kamEditInput,
  .submitError {
    flex: 1 1 100%;
    min-width: 0;
  }
}
